import * as types from './types';
import actions from './actions';
import {
  extend,
} from 'lodash';

const state = {
  //补订信息表
  bookAdditionalListModel: {
    state: '',
    total: undefined,
    list: [],
  }
}

const getters = {
  getBookAdditionalListModel: (state) => state.bookAdditionalListModel,
}

const mutations = {
  [types.STUDENT_BOOK_ADDITION](state,result){
    state.bookAdditionalListModel = extend({},result)
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/studentBookAddition/index.js